export const CONTAINER_CLASS = 'phone-field-container';

export const PREFERRED_COUNTRIES = ['us', 'ca', 'au'];
